<template>
	<vs-popup
		:title="'Éditer les marques de ' + society.name"
		:active.sync="popupActive"
		style="z-index: 99999"
	>
		<!-- Import Info Popup -->
		<vs-popup
			title="Résultats de l'importation"
			:active.sync="importResultsPopup"
			style="z-index: 999991"
		>
			<div class="p-4 flex flex-col items-center">
				<div class="text-center mb-6">
					<h3 class="text-xl font-medium mb-2">Détails de l'importation</h3>
					<div class="flex flex-col space-y-2">
						<div class="flex space-x-2">
							<div class="font-medium">Total importé:</div>
							<div>{{ importStats.imported }}</div>
						</div>
						<div class="flex space-x-2">
							<div class="font-medium">Doublons ignorés:</div>
							<div>{{ importStats.duplicates }}</div>
						</div>
					</div>
				</div>
				<vs-button @click="importResultsPopup = false" class="w-1/2"
					>Fermer</vs-button
				>
			</div>
		</vs-popup>
		<!-- Batch Delete Confirmation Popup -->
		<vs-popup
			title="Êtes-vous sûr de vouloir supprimer ?"
			:active.sync="batchDeleteConfirmationPopup"
			style="z-index: 999999991"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="removeBatch()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button
						class="mt-2 w-full"
						@click="batchDeleteConfirmationPopup = false"
					>
						Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<!-- Single Delete Confirmation Popup -->
		<vs-popup
			title="Êtes-vous sûr de vouloir supprimer ?"
			:active.sync="deleteConfirmationPopup"
			style="z-index: 9999999991"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="remove(selectedBrandId)"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button
						class="mt-2 w-full"
						@click="deleteConfirmationPopup = false"
					>
						Non</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<div>
			<div v-if="isLoading" class="text-center">
				<circular-loader />
			</div>
			<div v-else>
				<div class="keyword-editor">
					<!-- Add Brand Input -->
					<div class="add-keyword">
						<input
							v-model="newBrands"
							placeholder="Ajouter nouvelle marque..."
							@keyup.enter="add"
						/>
						<vs-button @click="add" color="primary" type="filled"
							>Ajouter</vs-button
						>
					</div>

					<!-- CSV Import/Export -->
					<div
						class="import-csv mt-4 flex justify-end items-center w-full space-x-5"
					>
						<div class="flex items-center space-x-2">
							<input
								type="file"
								ref="fileInput"
								style="display: none"
								accept=".csv, .xlsx, .xls"
								@change="handleCSVUpload"
							/>
							<vs-button
								@click="$refs.fileInput.click()"
								color="warning"
								type="border"
								>Import XLSX</vs-button
							>
							<a
								href="https://docs.google.com/spreadsheets/d/1PrCS4Vytxk6fbFEWEZPpf_gQKV0_pkPT80nQPyW9lCM/edit?gid=0#gid=0"
								target="_blank"
								rel="noopener noreferrer"
							>
								<vx-tooltip
									:text="'Premier ligne reservée pour les entêtes : Marque, Commentaire'"
									placement="top"
								>
									<vs-icon
										icon="description"
										size="small"
										color="black"
									></vs-icon>
								</vx-tooltip>
							</a>
						</div>

						<vs-button
							icon="cloud_download"
							color="primary"
							@click="exportToExcel"
						>
							Exporter
						</vs-button>
					</div>

					<!-- Brands Table -->
					<vs-table
						multiple
						v-model="selected"
						pagination
						max-items="30"
						search
						:data="brandsChips"
					>
						<template slot="header">
							<div class="pl-5 vx-row w-full space-x-5">
								<strong class="float-right"
									>Nombre de marques affichées :
									{{ brandsChips.length }}</strong
								>
								<div v-if="selected.length > 0">
									<vs-button
										color="danger"
										type="border"
										@click="batchDeleteConfirmationPopup = true"
									>
										Supprimer
									</vs-button>
								</div>
							</div>
						</template>
						<template slot="thead">
							<!-- <vs-th sort-key="isFav"></vs-th> -->
							<vs-th style="pointer-events: auto" sort-key="brand">
								Marque
							</vs-th>
							<vs-th sort-key=""> Actions </vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="data[indextr].brand">
									<div v-if="data[indextr].isEditing">
										<input
											v-model="data[indextr].editBrand"
											class="edit-input"
											@keyup.enter="saveEdit(data[indextr])"
										/>
									</div>
									<div v-else>
										{{ data[indextr].brand }}
									</div>
								</vs-td>

								<vs-td :data="data[indextr].brand" class="flex-actions">
									<vs-icon
										v-if="data[indextr].isEditing"
										icon="save"
										size="small"
										color="success"
										class="action-icon"
										@click.stop="saveEdit(data[indextr])"
									></vs-icon>
									<vs-icon
										v-else
										icon="edit"
										size="small"
										color="primary"
										class="action-icon"
										@click.stop="startEdit(data[indextr])"
									></vs-icon>
									<vs-icon
										icon="delete"
										size="small"
										color="danger"
										class="action-icon"
										@click.stop="onRemoveClick(data[indextr].id)"
									></vs-icon>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</div>
		</div>
	</vs-popup>
</template>
  
<script>
import XLSX from "xlsx";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import Society from "../../entities/Society";

export default {
	components: { CircularLoader },
	name: "BrandsManager",
	props: {
		society: {
			type: Object,
			required: true,
		},
		popupActive: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			brands: [], // local copy to manipulate
			brandsFullChips: [], // full list of brands
			brandsChips: [], // filtered list of brands
			brandsChipsKey: 0,
			newBrands: "",
			newBrandComment: "",
			nextId: 1,
			isLoading: false, // fallback id for new brands
			searchQuery: "",

			selected: [], // selected brands for deletion
			selectedBrandId: null, // id of the selected brand for single delete

			batchDeleteConfirmationPopup: false, // confirmation popup for batch delete
			deleteConfirmationPopup: false, // confirmation popup for single delete

			importResultsPopup: false,
			importStats: {
				imported: 0,
				duplicates: 0,
			},
		};
	},
	async created() {
		// Clone initial data and track max ID
		await this.getBrands();
	},
	watch: {
		searchQuery: {
			immediate: false,
			handler(query) {
				if (!query) {
					this.brandsChips = this.brandsFullChips;
				} else {
					this.brandsChips = this.brandsFullChips.filter((chip) =>
						chip.brand.toLowerCase().includes(query.toLowerCase())
					);
				}
			},
		},
		brandsFullChips: {
			immediate: true,
			handler(data) {
				this.brandsChips = data;
				const maxId = data.reduce((max, k) => (k.id > max ? k.id : max), 0);
				this.nextId = maxId + 1;
			},
		},
	},
	methods: {
		startEdit(brand) {
			// Set editing flags and prepare edit values
			this.$set(brand, "isEditing", true);
			this.$set(brand, "editBrand", brand.brand);
		},

		async saveEdit(brand) {
			try {
				const trimmedName = brand.editBrand.trim();
				if (!trimmedName) {
					this.$vs.notify({
						title: "Erreur",
						text: "Le nom de la marque ne peut pas être vide",
						color: "warning",
					});
					return;
				}

				const updateData = {
					brand: trimmedName,
				};

				await Society.updateBrand(updateData, brand.id);

				// Update local data
				brand.brand = trimmedName;
				brand.isEditing = false;

				this.$vs.notify({
					title: "Succès",
					text: "Marque mise à jour avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la mise à jour de la marque",
					color: "danger",
				});
				console.error(error);
			}
		},

		async getBrands() {
			try {
				this.isLoading = true;
				let brands = await Society.getBrands(this.$props.society.id);

				// Add editing flags to all brands
				brands = brands.map((brand) => ({
					...brand,
					isEditing: false,
					editBrand: "",
				}));

				this.brands = brands;
				this.brandsFullChips = brands.reverse();
				this.brandsChips = this.brandsFullChips;
				this.brandsChipsKey++;
				this.isLoading = false;
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la récupération des marques",
					color: "danger",
				});
				console.error(error);
				this.isLoading = false;
			}
		},
		async add() {
			try {
				const trimmed = this.newBrands.trim();
				if (!trimmed) return;

				let newBrand = {
					id: this.nextId++,
					society_id: this.$props.society.id || null,
					brand: trimmed,
					comment: this.newBrandComment,
					isFav: false,
					active: 1,
					isEditing: false,
				};
				await Society.addBrands([newBrand], this.$props.society.id);
				this.brandsFullChips.unshift(newBrand);

				this.newBrands = "";
				this.newBrandComment = "";

				this.$vs.notify({
					title: "Succès",
					text: "Marque ajoutée avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de l'ajout de la marque",
					color: "danger",
				});
				console.error(error);
			}
		},
		onRemoveClick(id) {
			this.deleteConfirmationPopup = true;
			this.selectedBrandId = id;
		},
		async remove(id) {
			try {
				await Society.deleteBrands(id);
				this.brandsFullChips = this.brandsFullChips.filter((k) => k.id !== id);
				this.deleteConfirmationPopup = false; // Close confirmation popup
				this.selectedBrandId = null; // Reset selected brand ID

				this.$vs.notify({
					title: "Succès",
					text: "Marque supprimée avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la suppression de la marque",
					color: "danger",
				});
				console.error(error);
			}
		},
		async removeBatch() {
			try {
				let ids = this.selected.map((k) => k.id);
				if (ids.length === 0) return;
				await Society.deleteBatchBrands(ids);

				this.brandsFullChips = this.brandsFullChips.filter(
					(k) => !ids.includes(k.id)
				);
				this.selected = []; // Clear selected brands
				this.batchDeleteConfirmationPopup = false; // Close confirmation popup

				this.$vs.notify({
					title: "Succès",
					text: "Marques supprimées avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la suppression des marques",
					color: "danger",
				});
				console.error(error);
			}
		},
		// Check if brand already exists
		isBrandDuplicate(brandName) {
			if (!brandName) return false;

			return this.brandsFullChips.some((brand) => {
				// Make sure both the brand and the name exist before comparing
				return (
					brand &&
					brand.brand &&
					brand.brand.toLowerCase() === brandName.toLowerCase()
				);
			});
		},

		// Updated import function for both CSV and XLSX with duplicate checking
		handleCSVUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			// Check if file is CSV or XLSX
			const fileExtension = file.name.split(".").pop().toLowerCase();
			if (
				fileExtension !== "csv" &&
				fileExtension !== "xlsx" &&
				fileExtension !== "xls"
			) {
				this.$vs.notify({
					title: "Erreur",
					text: "Seuls les fichiers CSV et Excel (XLSX/XLS) sont pris en charge",
					color: "danger",
				});
				return;
			}

			const reader = new FileReader();
			reader.onload = async (e) => {
				try {
					let newBrands = [];
					let rows = [];
					const result = e.target.result;

					// Parse file content - works for both CSV and XLSX
					const data = new Uint8Array(result);
					const workbook = XLSX.read(data, { type: "array" });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

					// Track duplicates for notification
					let duplicateCount = 0;

					// Skip the first row (header)
					rows.slice(1).forEach((row) => {
						// Safely extract the brand name and trim if exists
						const brandName = row && row[0] ? row[0].toString().trim() : "";
						if (!brandName) return;

						// Check if brand already exists
						if (this.isBrandDuplicate(brandName)) {
							duplicateCount++;
							return; // Skip this brand
						}

						// Add the new brand
						newBrands.unshift({
							id: this.nextId++,
							society_id: this.$props.society.id || null,
							brand: brandName,
							active: 1,
							isEditing: false,
						});
					});
					// Import Stats Popup
					this.importStats.imported = newBrands.length;
					this.importStats.duplicates = duplicateCount;
					this.importResultsPopup = true;

					if (newBrands.length > 0) {
						// Add the brands to the database
						await Society.addBrands(newBrands, this.$props.society.id);

						// Update local state
						this.brandsFullChips = newBrands.concat(this.brandsFullChips);
						this.brandsChipsKey++;

						let message = `${newBrands.length} marques importées avec succès`;
						if (duplicateCount > 0) {
							message += `, ${duplicateCount} doublons ignorés`;
						}

						this.$vs.notify({
							title: "Succès",
							text: message,
							color: "success",
						});
					} else if (duplicateCount > 0) {
						this.$vs.notify({
							title: "Information",
							text: `Aucune nouvelle marque importée, ${duplicateCount} doublons ignorés`,
							color: "primary",
						});
					} else {
						this.$vs.notify({
							title: "Information",
							text: "Aucune marque à importer",
							color: "primary",
						});
					}

					// Reset file input
					this.$refs.fileInput.value = "";
				} catch (error) {
					this.$vs.notify({
						title: "Erreur",
						text: "Échec de l'importation des marques",
						color: "danger",
					});
					console.error(error);
				}
			};
			reader.readAsArrayBuffer(file);
		},
		exportToExcel() {
			try {
				const dataToExport = this.brandsChips.map((item) => ({
					Marque: item.brand,
				}));

				const worksheet = XLSX.utils.json_to_sheet(dataToExport);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, "Marques");

				XLSX.writeFile(workbook, "export_marques.xlsx");

				this.$vs.notify({
					title: "Succès",
					text: "Marques exportées avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de l'exportation des marques",
					color: "danger",
				});
				console.error(error);
			}
		},
	},
};
</script>
  
<style scoped>
.keyword-editor {
	padding: 20px;
}
.add-keyword input {
	padding: 10px;
	margin-right: 10px;
	border: 1px solid #ccc;
}
.chips-wrapper {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
.edit-input {
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 4px;
	width: 100%;
}
.flex-actions {
	display: flex;
	gap: 10px;
}
.action-icon {
	cursor: pointer;
}
</style>